module.exports = __webpack_public_path__ + "img/carrot-food.5d0ce323.svg";